// @ts-nocheck
const DEFAULT_TIMEOUT = 5000;

const waitFor = (timeout: number) => new Promise((resolve) => setTimeout(resolve, timeout));

export default class Poller {
  constructor({ timeout } = { timeout: DEFAULT_TIMEOUT }) {
    this.timeout = timeout;
    this.isPolling = false;
  }

  timeout: number;

  isPolling: boolean;

  onFetch: () => Promise<void>;

  onSuccess: (data: any) => Promise<void>;

  onError: (error: Error) => Promise<void>;

  start(onFetch, onSuccess, onError) {
    this.onFetch = onFetch;
    this.onSuccess = onSuccess;
    this.onError = onError;

    if (!this.isPolling) {
      this.isPolling = true;

      this.poll();
    }
  }

  stop() {
    this.onFetch = null;
    this.onSuccess = null;
    this.onError = null;
    this.isPolling = false;
  }

  async poll() {
    while (this.isPolling) {
      const { handleFetch, handleSuccess, handleError } = this;

      try {
        await handleSuccess(await handleFetch());
      } catch (error) {
        await handleError(error);
      } finally {
        await waitFor(this.timeout);
      }
    }
  }

  handleFetch = (): Promise<void> => (this.onFetch ? this.onFetch() : null);

  handleSuccess = (data: any): Promise<void> => (this.onSuccess ? this.onSuccess(data) : null);

  handleError = (error: Error): Promise<void> => (this.onError ? this.onError(error) : null);
}
